<template>
  <div>
    <template v-if="submit==0">
      <div class="d-flex flex-row-column justify-content-between">
        <span class="page-title mt-3">Make a Deposit</span>
        <md-button
          v-on:click="$router.push('/lmt/deposit/history')"
          class="md-primary md-raised c-primary ml-0"
        >
          <template>History of Slips</template>
        </md-button>
      </div>
      <hr class />
      <div class="mt-3">
        <b-row>
          <b-col class="pl-5" md="8">
            In order to Make a Deposit you must fill the data below.
            <br />Enter Bank Name and Bank Account and choose Deposit Type, once filled click on Confirm.
          </b-col>
          <b-col class="pl-5 mt-4" md="12">
            <b-row>
              <b-col md="4">
                <select-component
                  label="Bank"
                  :form="form"
                  property="bank_id"
                  object="bank_id"
                  :values="banks"
                  display="name"
                  v-on:update="handleUpdate($event,'bank_id')"
                />
              </b-col>
              <b-col md="4">
                <select-component
                  label="Bank Account"
                  :form="form"
                  :disabled="form.bank_id==''"
                  property="bank_account_id"
                  :values="accounts.length>0?accounts:[{acc_number:'No Data'}]"
                  display="acc_number"
                  v-on:update="handleUpdate($event,'bank_account_id')"
                />
              </b-col>
              <b-col md="4">
                <select-component
                  label="Deposit Type"
                  :form="form"
                  property="deposit_type_id"
                  :values="types"
                  display="name"
                  v-on:update="handleUpdate($event,'deposit_type_id')"
                />
              </b-col>
            </b-row>
            <md-button
              @click="submit=1"
              :disabled="!ready"
              class="md-primary md-raised c-primary mt-4"
            >Confirm</md-button>
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-else>
      <create-deposit :data="form" />
    </template>
  </div>
</template>
<script>
import Create from "../../../components/lmt/deposit/Create";
export default {
  components: { "create-deposit": Create },
  data() {
    return {
      form: new Form({
        bank_id: "",
        bank_account_id: "",
        deposit_type_id: ""
      }),
      banks: [],
      types: [],
      accounts: [],
      ready: 0,
      submit: 0
    };
  },
  methods: {
    handleUpdate(event, property) {
      this.form[property] = event;

      if (property == "bank_id") {
        this.loadAccounts();
      }

      this.validateInput();
    },
    loadAccounts() {
      this.form.bank_account_id = "";
      axios
        .get("/lmt/deposit/bank-accounts?bank_id=" + this.form.bank_id)
        .then(({ data }) => {
          this.accounts = data.accounts;
        });
    },
    validateInput() {
      if (
        this.form.bank_account_id &&
        this.form.bank_id &&
        this.form.deposit_type_id
      ) {
        this.ready = 1;
      } else {
        this.ready = 0;
      }
    }
  },
  mounted() {
    axios.get("/lmt/deposit-types").then(({ data }) => {
      this.types = data.deposit_types;
    });
    axios.get("/lmt/deposit/banks").then(({ data }) => {
      this.banks = data.banks;
    });

    Event.$on("reset", data => {
      this.ready = 1;
      this.submit = 0;
    });
  }
};
</script>